import * as api from "~/api";
// import * as types from "./hospitalTypes";
import { HOSPITAL, RESOURCE } from "~/utils/urlApi";
import { createQueryString } from "~/utils/func";

export const requestHospitalList = () => {
  return api.getHttpRequest(HOSPITAL.REQUEST_HOSPITAL_LIST_URL);
};

export const requestHospitalListByFeatureId = id => {
  return api.getHttpRequestAsync(
    HOSPITAL.REQUEST_HOSPITAL_LIST_BY_FEATURE_ID_URL(id)
  );
};

export const requestFeatureByHospitalId = id => {
  return api.getHttpRequestAsync(
    HOSPITAL.REQUEST_FEATURE_LIST_BY_HOSPITAL_ID_URL(id)
  );
};

// API 1: GET /city-mongo/get-all-by-partner/v2?country_code=203
export const apiRequestAllCitiesV2ByCountry = (baseUrl = "", data) => {
  const url = createQueryString(`${baseUrl}${RESOURCE.GET_CITY_V2}`, data);
  return api.getHttpRequest(url);
};

// API 2: GET /ward-mongo/get-all-by-partner/v2?city_id=medpro_v2_79
export const requestAllWardsByCity = (baseUrl = "", data) => {
  const url = createQueryString(`${baseUrl}${RESOURCE.GET_WARD_V2}`, data);
  return api.getHttpRequest(url);
};
